import { useRef, useEffect } from 'react';

const useAutoExpandTextarea = (value, setCursorToEnd = false) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      const { scrollHeight } = textareaRef.current;
      textareaRef.current.style.height = `${scrollHeight}px`;

      // Set cursor to the end of the text if requested
      if (setCursorToEnd) {
        const textLength = textareaRef.current.value.length;
        textareaRef.current.setSelectionRange(textLength, textLength);
      }
    }
  }, [value, setCursorToEnd]);

  return textareaRef;
};

export default useAutoExpandTextarea;
